import React from 'react';

import ReactEChartsCore from 'echarts-for-react/lib/core';
import { PieChart } from 'echarts/charts';
import {
    GridComponent,
    LegendComponent,
    TitleComponent,
    TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { getColor } from 'helpers/utils';
import PropTypes from 'prop-types';

echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    PieChart,
    CanvasRenderer,
    LegendComponent
]);

const SalesByCategoryChart = ({ data }) => {
    const chartData = data.map(item => ({
        value: parseFloat(item.value.replace('%', '')),
        name: item.label
    }));

    const getOptions = () => ({
        color: data.map(item => getColor(item.color)),
        tooltip: {
            trigger: 'item',
            padding: [7, 10],
            backgroundColor: getColor('gray-100'),
            borderColor: getColor('gray-300'),
            textStyle: { color: getColor('dark') },
            borderWidth: 1,
            transitionDuration: 0,
            formatter: params =>
                `<strong>${params.data.name}:</strong> ${params.data.value}%`
        },
        legend: { show: false },
        series: [
            {
                type: 'pie',
                radius: ['100%', '65%'],
                avoidLabelOverlap: false,
                itemStyle: {
                    borderWidth: 2,
                    borderColor: getColor('gray-100')
                },
                label: {
                    show: false
                },
                emphasis: {
                    scale: false
                },
                data: chartData
            }
        ]
    });

    return (
        <ReactEChartsCore
            echarts={echarts}
            option={getOptions()}
            style={{ height: 200 }}
        />
    );
};

SalesByCategoryChart.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired, // ej. '45.3%'
            label: PropTypes.string.isRequired,
            color: PropTypes.string.isRequired
        })
    ).isRequired
};

export default SalesByCategoryChart;
